export default __webpack_public_path__ + "static/media/strips_subscription_guide@3x.0507432c.png";